export default function FormValidate() {
  function validateName(value) {
    if (value.length === 0) {
      return true;
    }
    return false;
  }

  function validatePhoneNumber(value) {
    const regx =
      /^(\+?(1\s)?)[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    if (regx.test(value) || value.length === 0) {
      return true;
    }
    return false;
  }

  function validateEmailAddress(value) {
    const regx =
      /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (regx.test(value) || value.length === 0) {
      return true;
    }
    return false;
  }

  function validateZipCode(value) {
    // USA ZIP Code can be in the format XXXXX or XXXXX-XXXX
    const usaZip = /(^\d{5}$)|(^\d{5}[ -]?\d{4}$)/;

    // Canadian Postal Code can be in the format ANA NAN
    const canadaZip = /(^[A-Za-z]\d[A-Za-z][ -]?(?:\d[A-Za-z]\d)?$)/;

    const valid = usaZip.test(value) || canadaZip.test(value);

    if (valid || value.length === 0) {
      return true;
    }
    return false;
  }

  function validateForm(value, type) {
    const validationType = {
      name: () => {
        return validateName(value);
      },
      phone: () => {
        return validatePhoneNumber(value);
      },
      email: () => {
        return validateEmailAddress(value);
      },
      zip: () => {
        return validateZipCode(value);
      },
      ziplocator: () => {
        return validateZipCode(value);
      },
      'default': () => true
    };

    return (validationType[type] || validationType['default'])();
  }

  function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  function displayError(ele, errorMessage) {
    const name = ele.getAttribute('name');
    const formId = `${ele.getAttribute('id')}_${name}-error`;
    const errorLabel = document.getElementById(formId);
    ele.setCustomValidity(errorMessage);
    ele.classList.add('error');

    if (!errorLabel) {
      const label = document.createElement('span');
      label.innerHTML = errorMessage;
      label.id = formId;
      label.classList.add('error');
      insertAfter(ele, label);
    } else {
      errorLabel.classList.add('error');
      errorLabel.style = 'display:block';
      errorLabel.innerHTML = errorMessage;
    }
  }

  function checkParentNode(parent, child) {
    let node = child.parentNode;
    while(node) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  //to get all form elements
  const formEle = document.querySelectorAll('.js-validate');

  //to get all submit button elements
  const submitForm = document.querySelectorAll('input[type=submit], button[type=submit]');

  formEle.forEach(item => {
    item.setAttribute('novalidate', 'novalidate');

    const elements = item.querySelectorAll(
      'input[type=text], input[type=tel], input[type=email], select'
    );

    //to handle error on form submit event
    submitForm.forEach(ele => {
      ele.addEventListener('click', () => {
        elements.forEach(formEle => {
          const isRequired = formEle.hasAttribute('required');
          const requiredErrorData = formEle.getAttribute('data-msg-required')
            ? formEle.getAttribute('data-msg-required')
            : formEle.validationMessage;
          const value = formEle.value.trim();
          formEle.value = value;

          if (checkParentNode(item, ele)) {
            if (!formEle.validity.valid) {
              // Check for active element and error class
              if (
                !document.activeElement ||
                !document.activeElement.classList.contains('error')
              ) {
                formEle.focus();
              }
            }

            if (isRequired) {
              if (!value && value.length === 0) {
                displayError(formEle, requiredErrorData);
                return true;
              }
            }
          }
        });
      });
    });

    //to handle error on blur, input and changes events
    elements.forEach(ele => {
      const name = ele.getAttribute('name');
      const formId = `${ele.getAttribute('id')}_${name}-error`;
      const requiredErrorData = ele.getAttribute('data-msg-required')
        ? ele.getAttribute('data-msg-required')
        : '*This field is required';
      const nameErrorData = ele.getAttribute('data-msg-name')
        ? ele.getAttribute('data-msg-name')
        : `Invalid ${
          ele.getAttribute('placeholder')
            ? ele.getAttribute('placeholder')
            : 'value'
        }`;
      const zipcodeErrorData = ele.getAttribute('data-msg-zip')
        ? ele.getAttribute('data-msg-zip')
        : 'Invalid zip/postal code';
      const isTypeName =
        name.includes('name') ||
        (ele.hasAttribute('data-msg-name') && !name.includes('zip'));
      const isTypeZip = name.includes('zip');
      const errorMessage = isTypeZip
        ? zipcodeErrorData
        : ele.getAttribute(`data-msg-${name}`);

      ele.addEventListener('blur', function() {
        const errorLabel = document.getElementById(formId);
        if (!errorLabel) {
          validateAndDisplayError(this, true);
        }
      });

      ele.addEventListener('input', function() {
        const errorLabel = document.getElementById(formId);
        if (errorLabel) {
          validateAndDisplayError(this, true);
        }
      });

      ele.addEventListener('change', () => {
        validateAndDisplayError(this, false);
      });

      function validateAndDisplayError(ele, useValidate) {
        const value = ele ? ele.value.trim() : '';

        const isRequired = ele ? ele.hasAttribute('required') : false;
        const errorLabel = document.getElementById(formId);
        const isValid = validateForm(value, isTypeName ? 'name' : name);
        ele.value = value;

        if (isRequired) {
          if (value && value.length) {
            if (errorLabel) {
              errorLabel.style = 'display:none';
              errorLabel.classList.remove('error');
              ele.classList.remove('error');
              ele.setCustomValidity('');
            }
          } else {
            displayError(ele, requiredErrorData);
            return true;
          }
        }

        if (useValidate) {
          if (isValid) {
            if (errorLabel) {
              errorLabel.style = 'display:none';
              errorLabel.classList.remove('error');
              ele.classList.remove('error');
              ele.setCustomValidity('');
            }
          } else {
            if (!isTypeName) {
              displayError(ele, errorMessage);
            }
          }
        }
      }
    });
  });

  return (
    displayError
  );
}



// WEBPACK FOOTER //
// ./src/bb/js/components/FormValidate.js